import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("og_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Super Admin works on the branch picked in the header; the server ignores this for everyone else
  const branch = localStorage.getItem("og_branch");
  const url = config.url || "";
  if (branch && !/^\/(auth|portal|agent-portal|branches)/.test(url)) {
    if (!/[?&]branch_id=/.test(url) && !(config.params && config.params.branch_id)) {
      config.params = { ...(config.params || {}), branch_id: branch };
    }
    const d = config.data;
    const isCreate = (config.method || "").toLowerCase() === "post" && !/^\/users/.test(url);
    if (isCreate && d && typeof d === "object" && !(d instanceof FormData) && !Array.isArray(d) && !d.branch_id) {
      config.data = { ...d, branch_id: branch };
    }
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("og_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(err) {
  const detail = err.response?.data?.detail;
  if (detail == null) return err.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
